import { useCreateAdvertiserWithUserV2Mutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AdvertiserForm, AdvertiserFormValues } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const AddAdvertiser = () => {
  useUpdateDocumentTitle({
    title: 'documentTitle.AddAdvertiser',
    appHeader: 'appHeader.Add New Advertiser',
    href: '/advertiser'
  });
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callCreateAdvertiserWithUserV2 } = useCreateAdvertiserWithUserV2Mutation();

  const handleSubmit: FormAction<AdvertiserFormValues>['onSubmit'] = async ({
    hubspotId,
    countryId,
    companyUrl,
    phoneNumber,
    advertiserId,
    isNewlyCreated,
    advertiserName,
    internalNetsuiteId,
    ...rest
  }) => {
    try {
      await callCreateAdvertiserWithUserV2({
        variables: {
          input: {
            selectedAdvertiserId: isNewlyCreated ? null : Number(advertiserId),
            newAdvertiserInput: isNewlyCreated
              ? {
                  hubspotId: hubspotId || null,
                  internalNetsuiteId: internalNetsuiteId || null,
                  advertiserName: advertiserName || '',
                  countryId,
                  phoneNumber: phoneNumber || null,
                  companyUrl: companyUrl || null
                }
              : null,
            user:
              rest.type === 'add' && (rest.userName || rest.email)
                ? {
                    email: rest.email,
                    userName: rest.userName,
                    password: rest.password || undefined,
                    hasInvitationEmail: rest.shouldSendInvitation
                  }
                : null
          }
        }
      });
      enqueueSnackbar(t('succeededInCreating', { name: advertiserName }), { variant: 'success' });
      navigate({ to: '/advertiser' });
    } catch (error) {
      enqueueSnackbar(t('failedToCreate', { name: advertiserName }), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <div>
      <Header />
      <AdvertiserForm onSubmit={handleSubmit} />
    </div>
  );
};
